import { render, staticRenderFns } from "./EquipmentShiftHazardNotesDialog.vue?vue&type=template&id=cf5a37c4&scoped=true&"
import script from "./EquipmentShiftHazardNotesDialog.vue?vue&type=script&lang=ts&"
export * from "./EquipmentShiftHazardNotesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5a37c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
